var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInhaler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1173_54385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H22V22H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1173_54385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2529 4.93113L20.5048 7.08594L21.707 3.78293L17.2138 2.29117L16.2529 4.93113Z",
    stroke: "#737373",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5088 7.17219L15.2258 5.20227C15.3553 4.84644 15.7667 4.68387 16.1045 4.85504L20.7893 7.22926C21.0743 7.37367 21.2064 7.7082 21.0972 8.00836L19.7425 11.7305",
    stroke: "#737373",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2746 13.0191L16.4905 20.6685C16.2636 21.292 15.6709 21.707 15.0073 21.707H10.4424V16.1486H11.2428L14.0391 8.46601",
    stroke: "#737373",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84109 16.1486H7.0332V21.707H10.4424V16.1486H9.2102",
    stroke: "#737373",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3848 17.2866C16.3848 17.6353 16.1021 17.918 15.7534 17.918C15.4047 17.918 15.1221 17.6353 15.1221 17.2866C15.1221 16.9379 15.4047 16.6552 15.7534 16.6552C16.1021 16.6552 16.3848 16.9379 16.3848 17.2866Z",
    stroke: "#737373",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4355 19.81C15.4355 20.1587 15.1529 20.4414 14.8042 20.4414C14.4555 20.4414 14.1729 20.1587 14.1729 19.81C14.1729 19.4614 14.4555 19.1787 14.8042 19.1787C15.1529 19.1787 15.4355 19.4614 15.4355 19.81Z",
    stroke: "#737373",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77012 18.2189H5.32586C5.13031 18.2189 4.97441 18.0587 4.97617 17.8632C4.97641 17.8391 4.97562 17.8146 4.97379 17.79C4.94223 17.3607 4.59035 17.014 4.16055 16.9887C3.65734 16.9591 3.24 17.3585 3.24 17.8553C3.24 17.8984 3.24324 17.9408 3.24934 17.9823C3.24621 17.9823 3.24312 17.9821 3.24 17.9821C2.71695 17.9821 2.29297 18.4061 2.29297 18.9291C2.29297 19.4522 2.71695 19.8762 3.24 19.8762C3.24312 19.8762 3.24621 19.876 3.24934 19.8759C3.23723 19.9585 3.23629 20.0447 3.25004 20.1334C3.31473 20.5515 3.68059 20.8689 4.10359 20.8711C4.58512 20.8735 4.97621 20.4839 4.97621 20.003V19.9991C4.97531 19.802 5.12891 19.6394 5.32602 19.6394H5.77012V18.2189Z",
    stroke: "#737373",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhaler);
export default __webpack_public_path__ + "static/media/inhaler.7162ddc8ff519226bad2a971fd628b00.svg";
export { ForwardRef as ReactComponent };